import { Icon } from "@/components/icons/Icon";
import { Pill } from "@/components/pill/Pill";
import type { IAnswer, IQuestion } from "@/types/types";
import EmptyAnwer from "../answer/EmptyAnswer";
import PhasesResume from "./PhasesResume";
import { useLanguage } from "@/context/language-context/LanguageContext";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { InpectionPhase } from "../../inspection.d";
import { useState } from "react";
import { ModalMobile } from "@/components/modal/mobile/ModalMobile";
import IconButton from "@/components/buttons/IconButton";
import { cn } from "@/lib/styles.utils";
import Carousel from "@/components/carousel/Carousel";
import EditableAnswerMobile from "./answers/EditableAnswerMobile";

const QuestionCard = ({
  question,
  answer,
  index,
  phaseDate,
  restOfAnswers,
}: {
  question: IQuestion;
  answer: IAnswer | null;
  index: number;
  phaseDate: {
    phaseLabel: string;
    currentPhase: number;
    phases: InpectionPhase[];
  };
  restOfAnswers: { [phaseId: number]: IAnswer[] };
}) => {
  const [viewQuestion, setViewQuestion] = useState(false);
  const { language } = useLanguage();
  const translate = useTranslate();

  const { phaseLabel, currentPhase, phases } = phaseDate;

  const handleView = () => {
    setViewQuestion((prev) => !prev);
  };

  const handleClose = () => {
    setViewQuestion(false);
  };

  return (
    <>
      <div key={`mobile-question-${question.questionId}`} className="p-4">
        <div className="border border-ib-gray-borders rounded-sm divide-y ">
          <div
            onClick={handleView}
            role="button"
            key={`mobile-${question.questionId}`}
            className="flex gap-2 rounded-sm p-4"
          >
            <div>
              <p className="text-md">{index}.</p>
            </div>
            <div className="flex flex-col gap-2">
              <p
                className="text-md text-left"
                style={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {question[language]}
              </p>
              <div className="flex">
                <Pill
                  icon="images"
                  iconClassName="size-3"
                  className="bg-ib-gray-lightest"
                  label={question.images.length}
                />
              </div>
            </div>
          </div>
          {currentPhase && (
            <div className="flex flex-col p-4 gap-3">
              <div className="flex gap-2 items-center">
                <Icon name="lockOpen" className="size-4" />
                <h4 className="font-ib-bold">{translate(phaseLabel)}</h4>
              </div>
              {answer ? (
                <EditableAnswerMobile
                  question={question}
                  answer={answer}
                  phaseLabel={phaseLabel}
                />
              ) : (
                <EmptyAnwer questionId={question.questionId} />
              )}
            </div>
          )}
          <PhasesResume
            phases={phases}
            currentPhase={currentPhase}
            question={question}
            phaseLabel={phaseLabel}
            restOfAnswers={restOfAnswers}
            index={index}
          />
        </div>
      </div>
      {viewQuestion && (
        <ModalMobile>
          <ModalMobile.Header className="border-b ">
            <div className="w-full flex justify-between items-center">
              <div className=" flex-1 flex items-center space-x-4">
                <h3 className="text-lg">{`${translate("action")} ${index}`}</h3>
                <Pill
                  icon={closed ? "lockClose" : "refresh"}
                  label={translate(phaseLabel)}
                  className={cn(closed ? "bg-ib-gray-lightest" : "bg-ib-blue")}
                  iconClassName=""
                />
              </div>
              <IconButton
                icon="close"
                onClick={handleClose}
                iconClassName={"size-6"}
                className={"bg-transparent text-ib-red-main"}
              />
            </div>
          </ModalMobile.Header>
          <ModalMobile.Content className="bg-ib-gray-lightest-2">
            <div>
              <div></div>
              <Carousel urls={question.images} />
              <p>{question[language]}</p>
            </div>
          </ModalMobile.Content>
        </ModalMobile>
      )}
    </>
  );
};

export default QuestionCard;
